import {
  Component,
  EventEmitter,
  Input,
  Output,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Reusable drag-and-drop / click-to-browse file picker box.
 *
 * Purely presentational: it only tracks drag-over state and emits whichever File the user
 * picked or dropped. Type/size/content validation is left to the caller since it varies per
 * consumer (e.g. add-license-plates-modal's CSV/XLSX + column checks vs. a simpler consumer).
 */
@Component({
  selector: 'app-file-upload-dropzone',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './file-upload-dropzone.component.html',
  styleUrls: ['./file-upload-dropzone.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class FileUploadDropzoneComponent {
  @Input() accept = '.csv,.xlsx,.xls';
  @Input() title = 'Drag your file here or';
  @Input() browseLinkText = 'click to upload';
  @Input() subtitle = 'CSV or XLSX (max 10MB)';
  @Output() fileSelected = new EventEmitter<File>();

  readonly isDragOver = signal(false);

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    this.isDragOver.set(true);
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    this.isDragOver.set(false);
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    this.isDragOver.set(false);
    const file = event.dataTransfer?.files[0];
    if (file) {
      this.fileSelected.emit(file);
    }
  }

  onBrowseFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (file) {
      this.fileSelected.emit(file);
    }
    // Reset so selecting the same file again still fires a change event.
    input.value = '';
  }
}
